var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('portlet',{attrs:{"actionsBlock":true,"icon":'fad fa-pencil',"title":_vm.$t('instructions.createInstruction')}},[_c('template',{slot:"actionsBlock"},[_c('back-button',{attrs:{"link":'instructions'}})],1),_c('template',{slot:"portletBody"},[_c('InstructionsForm')],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }